import _ from 'lodash';
import moment from 'moment';
import Vue from 'vue';
import Cookies from 'cookies-js';
import {AxiosResponse} from 'axios';
import {mapActions, mapGetters} from 'vuex';
import EventHub from '../../lib/eventHub';
import LifeSpaService from '../../lib/services/lifeSpaService';
import {ClubModuleConstant, EventConstant, MemberStateConstant, ServiceConstant, ProfileModuleConstant, StorageConstant, UrlModuleConstant, CookieConstant, BookingConstant} from '../../lib/constants';
import BookingSchedule from './booking-schedule.html';
import {storageService} from '../../lib/services/storageService';
import LifeSpa from 'types/ls/lifespa';
import LtFramework from 'types/lt/ltFramework';
import Datepicker from 'vue-bootstrap-datetimepicker';

interface IComponentData {
	lifeSpaServiceLoading: boolean;
	club: LtFramework.IClub;
    categories: LifeSpa.ILifeSpaCategory[];
	serviceId: string;
    today: string;
    selectedDate: string;
    datepicker: any;
    datepickerType: string;
    datepickerOptions: any;
    datebarDates: LifeSpa.ILifeSpaDatebarDate[];
    datebarUpdating: boolean;
    datebarDisableBack: boolean;
    fullScheduleData: Array<{}>;
    schedule: Array<{}>;
    serviceKeys: any;
	technicians: any[];
	time: any;
	technicianFilter: any;
	timeFilter: any;
	dateCounts: any;
	telephone: string;
	bookingConfirmationPage: string;
	bookingDetailPage: string;
	profile: LtFramework.IProfile;
	spabizToken: string;
	loginPath: string;
	connectionError: boolean;
}

const lifeSpaService: LifeSpa.ILifeSpaService = new LifeSpaService();

export default Vue.component('lifeSpaSchedule', {
	template: BookingSchedule,
	data(): IComponentData {
		return {
			lifeSpaServiceLoading: true,
			club: {} as LtFramework.IClub,
            categories: [],
			serviceId: '',
            today: moment().format('DD-MMM-YYYY').toUpperCase(),
            selectedDate: moment().format('DD-MMM-YYYY').toUpperCase(),
            datepicker: moment().format('YYYY-MM-DD'),
            datepickerType: 'text',
            datepickerOptions: {
            	format: 'YYYY-MM-DD',
				widgetPositioning: {
					horizontal: 'left',
					vertical: 'bottom',
				},
				minDate: moment().format('YYYY-MM-DD'),
				ignoreReadonly: true,
            },
            datebarDates: [],
            datebarUpdating: false,
            datebarDisableBack: true,
			fullScheduleData: [],
            schedule: [],
            serviceKeys: {},
			technicians: [],
			time: [],
			technicianFilter: 'Anyone',
			timeFilter: 'Any',
			dateCounts: {},
			telephone: '',
			bookingConfirmationPage: '',
			bookingDetailPage: '',
			profile: {} as LtFramework.IProfile,
			spabizToken: '',
			loginPath: '',
			connectionError: false,
		};
	},
	components: {
		datepicker: Datepicker,
	},
	computed: {
		...mapGetters(UrlModuleConstant.name, {
			getGlobalPageDriverUrl: UrlModuleConstant.getter.getGlobalPageDriverUrl,
			getUrlParameter: UrlModuleConstant.getter.getUrlParameter,
		}),
		serviceOptionsLoading: function() {
			return this.lifeSpaServiceLoading && this.categories.length <= 0;
		},
		weekStart: function(): string {
			return moment(this.selectedDateMoment).startOf('week').format('DD-MMM-YYYY').toUpperCase();
		},
		weekStartMoment: function(): any {
			return moment(this.weekStart, 'DD-MMM-YYYY');
		},
		todayMoment: function(): any {
			return moment(this.today, 'DD-MMM-YYYY');
		},
		selectedDateMoment: function(): any {
			return moment(this.selectedDate, 'DD-MMM-YYYY');
		},
		canBook: function(): any {
			return this.profile.memberState === MemberStateConstant.authenticated || this.profile.memberState === MemberStateConstant.remembered && this.spabizToken;
		},
	},
	methods: {
		// store synchronization methods
		...mapActions(ClubModuleConstant.name, {
			synchronizeClubStore: ClubModuleConstant.action.synchronize,
		}),
		...mapActions(ProfileModuleConstant.name, {
			synchronizeProfileStore: ProfileModuleConstant.action.synchronize,
		}),
		...mapActions(UrlModuleConstant.name, {
			synchronizeUrlStore: UrlModuleConstant.action.synchronize,
		}),
		// component methods
		previousWeek() {
			this.selectedDateMoment.subtract(1, 'week');
			if (this.selectedDateMoment.isBefore(this.todayMoment)) {
				this.selectedDate = this.todayMoment.format('DD-MMM-YYYY').toUpperCase();
			} else {
				this.selectedDate = this.selectedDateMoment.format('DD-MMM-YYYY').toUpperCase();
			}
		},
		nextWeek() {
			this.selectedDate = this.selectedDateMoment.add(7, 'days').format('DD-MMM-YYYY').toUpperCase();
		},
		testTouch(event: any) {
			const el: any = $(event.target);
			if (el.attr('type') !== 'date') {
				event.preventDefault();
				el.attr('type', 'date');
				el.addClass('datepicker-hide');
				el.focus();
			}
		},
		updateDatepickerDate() {
			this.selectedDate = moment(this.datepicker).format('DD-MMM-YYYY').toUpperCase();
		},
		clearScheduleData() {
			this.fullScheduleData = [];
			this.schedule = [];
			this.technicianFilter = 'Anyone';
			this.timeFilter = 'Any';
		},
		filterSchedule() {
			const data = JSON.parse(JSON.stringify(this.fullScheduleData));
			this.schedule = [];
			this.dateCounts = {};

			_.forEach(data, (day: any) => {
				let count: number = 0;
				const scheduleDay: any = {};
				const serviceName: string = this.serviceKeys[this.serviceId].serviceName;
				const description: string = this.serviceKeys[this.serviceId].description;
				const images: LifeSpa.IImage[] = this.serviceKeys[this.serviceId].images;

				scheduleDay.name = day.name;
				scheduleDay.date = moment(day.date, 'DD-MMM-YY').format('DD-MMM-YYYY').toUpperCase();

				scheduleDay.dayparts = [{
					name: 'Morning',
					class: 'morning',
					times: [],
				},
				{
					name: 'Midday',
					class: 'midday',
					times: [],
				},
				{
					name: 'Evening',
					class: 'evening',
					times: [],
				}];

				day.slots = _.sortBy(day.slots, ['duration', 'name']);

				if (this.technicianFilter !== 'Anyone') {
					day.slots = _.remove(day.slots, (slot: any) => {
						return slot.staffId === this.technicianFilter;
					});
				}

				_.forEach(day.slots, (slot: any) => {
					slot.moment = moment(slot.value, 'h:m a');
					slot.serviceName = serviceName;
					slot.serviceId = this.serviceId;
					slot.description = description;
					if (images[0]) {
						slot.detailImage = images[0].image;
					}
					if (slot.moment.isBefore(moment('11:00 AM', 'h:m a'))) {
						if (this.timeFilter === 'Any' || this.timeFilter === 'Morning') {
							scheduleDay.dayparts[0].times.push(slot);
							count++;
						}
					} else if (slot.moment.isBefore(moment('4:00 PM', 'h:m a'))) {
						if (this.timeFilter === 'Any' || this.timeFilter === 'Midday') {
							scheduleDay.dayparts[1].times.push(slot);
							count++;
						}
					} else if (this.timeFilter === 'Any' || this.timeFilter === 'Evening') {
						scheduleDay.dayparts[2].times.push(slot);
						count++;
					}
				});

				_.remove(scheduleDay.dayparts, (daypart: any) => {
					return daypart.times.length === 0;
				});

				this.dateCounts[scheduleDay.date] = {count: count};

				_.forEach(scheduleDay.dayparts, (daypart: any) => {
					daypart.times = _(daypart.times).orderBy('moment').groupBy('value').map((value, key) => ({name: key, slots: value})).value();
				});

				this.schedule.push(scheduleDay);
			});
		},
		storeScheduleInfo(slot: LifeSpa.ISlot) {
			slot.bookingInfo = {
				serviceId: this.serviceId,
				technician: this.technicianFilter,
				date: this.selectedDate,
				time: this.timeFilter,
				bookingPage: window.location.href,
				participant: this.profile.memberDetails ? this.profile.memberDetails.firstname : undefined,
			};
			storageService.set(StorageConstant.lifespaSlot, slot);
		},
		goDetail(slot: LifeSpa.ISlot, e: Event) {
			e.preventDefault();
			this.storeScheduleInfo(slot);
			window.location.assign(this.bookingDetailPage);
		},
		book(slot: LifeSpa.ISlot, e: Event) {
			e.preventDefault();

			const spabizToken: string = Cookies.get(CookieConstant.spabizToken);

			if (spabizToken) {
				const bookAppointmentData: LifeSpa.ISpaBizAppointmentInfo = {
					locationId: this.club.id.toString(),
					id: this.serviceId,
					staffId: slot.staffId,
					timeslot: moment(slot.fulldatetime, 'DD-MMM-YYYY H:mm A').format('DD-MMM-YYYY H:mm'),
					customerId: spabizToken,
					endTime: slot.duration.toString(),
					channel: BookingConstant.channelId,
				};
				this.storeScheduleInfo(slot);
				lifeSpaService.bookAppointment(bookAppointmentData).then((response: AxiosResponse<LifeSpa.ISpaBizAppointmentResponse>) => {
					window.location.assign(this.bookingConfirmationPage);
				}).catch((error: any) => {
					if (error.response && error.response.status === 409) {
						const msg: string = ServiceConstant.bookingError.replace('{{availableBookings}}', this.club.pages.lifespaBooking + '?serviceId=' + this.serviceId);
						window.LtFramework.actions.createDangerNotification(msg, false, true);
					}
				});
			} else {
				// get customer id from spabiz
				const loginData: LifeSpa.ISpaBizLoginData = {
					locationId: this.club.id,
					accessToken: this.profile.sso,
				};
				lifeSpaService.getSpaBizUser(loginData).then((response: AxiosResponse<LifeSpa.ISpaBizUser>) => {
					Cookies.set(CookieConstant.spabizToken, response.data.id, {expires: CookieConstant.spabizTokenExpires});
					const bookAppointmentData: LifeSpa.ISpaBizAppointmentInfo = {
						locationId: this.club.id.toString(),
						id: this.serviceId,
						staffId: slot.staffId,
						timeslot: moment(slot.fulldatetime, 'DD-MMM-YYYY H:mm A').format('DD-MMM-YYYY H:mm'),
						customerId: response.data.id.toString(),
						endTime: slot.duration.toString(),
						channel: BookingConstant.channelId,
					};
					this.storeScheduleInfo(slot);
					lifeSpaService.bookAppointment(bookAppointmentData).then((appointmentResponse: AxiosResponse<LifeSpa.ISpaBizAppointmentResponse>) => {
						window.location.assign(this.bookingConfirmationPage);
					});
				}).catch((error: any) => {
					if (error.response && error.response.status === 409) {
						const msg: string = ServiceConstant.bookingError.replace('{{availableBookings}}', this.club.pages.lifespaBooking + '?serviceId=' + this.serviceId);
						window.LtFramework.actions.createDangerNotification(msg, false, true);
					}
				});
			}
		},
		updateAppointments() {
			this.technicians = [];
			if (this.serviceId !== '') {
				this.getAppointments(this.club.id, this.weekStart, this.serviceId, 1).then((response: AxiosResponse<LifeSpa.ILifeSpaWeekday[]>) => {
					this.connectionError = false;
					this.fullScheduleData = response.data;

					// build technician data
					_.forEach(this.fullScheduleData, (day: any) => {
						_.forEach(day.slots, (slot: any) => {
							this.technicians.push({
								staffId: slot.staffId,
								name: slot.name,
							});
						});
					});
					let returnObj: any = [];
					if (this.technicians.length > 0) {
						// filter out duplicate results
						returnObj = _.uniqBy(_.flatten(this.technicians), (b: any) => {
							return b.name;
						});
					}
					this.technicians = _.orderBy(returnObj, 'name');

					// filter data with current selections
					this.filterSchedule();
				}).catch((error: any) => {
					this.connectionError = true;
					this.clearScheduleData();
				});
			} else {
				this.connectionError = false;
				this.clearScheduleData();
			}
		},
		populateDatebar() {
			let startMonth = '';

			this.datebarUpdating = true;
			this.datebarDates = [];
			this.datebarDisableBack = this.weekStartMoment.isBefore(this.todayMoment);

			for (let i = 0; i < 7; i++) { // build out full week
				const obj: any = {};
				const m = moment(this.weekStartMoment).add(i, 'day');
				let monthName: string = '';

				obj.dateString = m.format('DD-MMM-YYYY').toUpperCase();
				obj.a11yDate = m.format('dddd MMMM D');

				m.locale('en-ltf');
				monthName = m.format('MMM');
				if (monthName !== startMonth) {
					obj.monthName = monthName;
					startMonth = monthName;
				}
				obj.dayNameShort = m.format('dd');
				obj.dayNameLong = m.format('ddd');
				obj.dayNumber = m.format('D');
				m.locale('en');
				obj.disabled = m.isBefore(this.todayMoment);

				this.datebarDates.push(obj);
			}
			this.datebarUpdating = false;
		},
		updateUrl() {
			let paramString: string = '?selectedDate=' + this.selectedDate;
			if (this.serviceId !== '') {
				paramString += '&serviceId=' + this.serviceId;
			}
			if (this.technicianFilter !== 'Anyone') {
				paramString += '&technician=' + this.technicianFilter;
			}
			window.LtFramework.actions.updateUrl(window.location.pathname + paramString);
		},
		getSpaCategories(clubId: number) {
			return lifeSpaService.getSpaCategories(clubId);
		},
		getAppointments(clubId: number, start: string, serviceId: string, weeks: number) {
			return lifeSpaService.getAppointments(clubId, start, serviceId, weeks);
		},
		getClubInfo(clubId: number) {
			return lifeSpaService.getClubInfo(clubId);
		},
	},
	watch: {
		serviceId() {
			this.updateAppointments();
			this.updateUrl();
		},
		technicianFilter() {
			this.filterSchedule();
			this.updateUrl();
		},
		timeFilter() {
			this.filterSchedule();
		},
		selectedDate() {
			// week start has changed
			if (this.selectedDateMoment.isValid() && this.weekStart !== this.datebarDates[0].dateString) {
				this.populateDatebar();
				this.updateAppointments();
			}
			this.updateUrl();
		},
		selectedDateMoment() {
			const newDate = this.selectedDateMoment.format('YYYY-MM-DD');
			if (newDate !== this.datepicker) {
				this.datepicker = newDate;
			}
		},
	},
	created(): void {
		EventHub.$on(EventConstant.LifeSpaServiceLoading, (loading: boolean) => {
			this.lifeSpaServiceLoading = loading;
		});
		// sticky headers requires overflow to be visible
		$('main').css('overflow', 'visible').addClass('bg-gray-12');
		moment.locale('en-ltf', {
			monthsShort : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
			weekdaysMin : ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
		});
		moment.locale('en');

		this.populateDatebar();
		// @ts-ignore
		Promise.all([this.synchronizeClubStore(), this.synchronizeUrlStore(), this.synchronizeProfileStore()]).then(() => {
			this.profile = window.LtFramework.getStore('ProfileStore').getInitialData();
			this.loginPath = window.LtFramework.getStore('UrlStore').getInitialData().globalPageDrivers.loginResource;
			this.club  = window.LtFramework.getStore('ClubStore').getInitialData();
			if (this.club.pages) {
				this.bookingConfirmationPage = this.club.pages.lifespaBookingConfirmation;
				this.bookingDetailPage = this.club.pages.lifespaBookingDetail;
			}
			// @ts-ignore
			const serviceIdParam: string = this.getUrlParameter('serviceId');
			// @ts-ignore
			const dateParam: string = this.getUrlParameter('selectedDate');
			// @ts-ignore
			const technicianParam: string = this.getUrlParameter('technician');
			this.spabizToken = Cookies.get(CookieConstant.spabizToken);
			// code here to extract club info from store
			this.getSpaCategories(this.club.id).then((response: AxiosResponse<LifeSpa.ILifeSpaCategories>) => {
				this.categories = _.sortBy(response.data.categories, 'name');
				_.forEach(this.categories, (category: LifeSpa.ILifeSpaCategory) => {
					_.forEach(category.services, (service: LifeSpa.ILifeSpaOffering) => {
						this.serviceKeys[service.id] = {
							serviceName: service.serviceName,
							description: service.description,
							images: service.images,
						};
					});
				});
				// set filters from url params
				if (serviceIdParam && this.serviceKeys[serviceIdParam] ) {
					this.serviceId = serviceIdParam;
				}
				if (dateParam && moment(dateParam, 'DD-MMM-YYYY').isSameOrAfter(moment())) {
					this.selectedDate = dateParam;
				}
				if (technicianParam) {
					this.technicianFilter = technicianParam;
				}
				// set additional filters if applicable
				const slot: LifeSpa.ISlot = storageService.get<LifeSpa.ISlot>(StorageConstant.lifespaSlot) as LifeSpa.ISlot;
				if (slot && slot.bookingInfo) {
					this.serviceId = slot.bookingInfo.serviceId;
					this.technicianFilter = slot.bookingInfo.technician;
					this.timeFilter = slot.bookingInfo.time;
					if (moment(slot.bookingInfo.date, 'DD-MMM-YYYY').isSameOrAfter(moment())) {
						this.selectedDate = slot.bookingInfo.date;
					}
				}
			}).catch((error: any) => {
				if (error.response && (error.response.status === 500 || error.response.status === 404)) {
					window.LtFramework.actions.createDangerNotification(ServiceConstant.errorMessage, false, true);
				}
			});
			this.getClubInfo(this.club.id).then((response: AxiosResponse<LifeSpa.IClubInfo>) => {
				this.telephone = response.data.data.data.location.settings.phone;
			});
		});
	},
});
